// BASIC:
import React from "react"
import "./style.sass"

// UTILITIES:
import { useStaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"

// COMPONENT=>
const Bio = () => {
  const data = useStaticQuery(graphql`
    query BioQuery {
      avatar: file(absolutePath: { regex: "/salih-avatar.jpg/" }) {
        childImageSharp {
          fluid(quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      site {
        siteMetadata {
          author {
            name
            summary
          }
          siteUrl
          social {
            twitter
          }
        }
      }
    }
  `)

  // Set these values by editing "siteMetadata" in gatsby-config.js
  const author = data.site.siteMetadata?.author
  const social = data.site.siteMetadata?.social
  const siteUrl = data.site.siteMetadata?.siteUrl

  const avatar = data?.avatar?.childImageSharp?.fluid

  return (
    <section className="bio">
      <div className="img-wrapper">
        {avatar && (
          <div className="avatar">
            <Image
              fixed={avatar}
              alt={author?.name || ``}
              className="author-avatar"
              imgStyle={{
                borderRadius: `50%`,
              }}
            />
          </div>
        )}
      </div>
      <div className="txt-wrapper">
        {author?.name && (
          <p className="author-info">
            Written by{" "}
            <strong>
              <a href={siteUrl}>{author.name}</a>
            </strong>{" "}
            {author?.summary || null}
            {` `}
            <a target="_blank" rel="noreferrer" href={`https://twitter.com/${social?.twitter || ``}`}>
              Follow him on twitter
            </a>
          </p>
        )}
      </div>
    </section>
  )
}

export default Bio
